function initMainSwiper() {
	if (document.querySelector('.section-catalog') != null) {
		let parentElem = document.querySelector('.section-catalog')
		let list = parentElem.querySelector('.catalog-header__list-product')
		let listItem = list.querySelectorAll('.catalog-header__list-item-product')
		let disabledArr = new Array()

		listItem.forEach((el, id) => {
			if (id > 5 && id != listItem.length - 1) {
				el.classList.add('list-menu-catalog--disabled')
				disabledArr.push(el)
			}
		})

		let actionButton = listItem[listItem.length - 1]
		let banners = document.querySelector('.section-catalog__images-list')
		actionButton.onclick = () => {
			banners.classList.toggle('section-catalog__images-list--disabled')
			banners.classList.toggle('section-catalog__images-list--active')

			actionButton.classList.toggle('list-menu-catalog--active')

			disabledArr.forEach(el => {
				el.classList.toggle('list-menu-catalog--disabled')
				el.classList.toggle('list-menu-catalog--active')
			})
		}
	}
}
